module.exports = __webpack_public_path__ + "img/1.82c66d87.jpg";